import { IWorkbookRevision } from '../types/IContentRevision';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from './Request';

export interface IGetWorkbookVersionsParams extends IGetItemsParams {
}

export interface IGetWorkbookVersionsResult extends IGetItemsResult {
  versions: IWorkbookRevision[];
}

export class GetWorkbookVersionsRequest extends Request<IGetWorkbookVersionsParams, IGetWorkbookVersionsResult> {
  constructor(params: IGetWorkbookVersionsParams) {
    super('getWorkbookVersions', params);
  }
}
